<script>
import lazyLoadComponent from '@router/lazyload-component'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      submitData: cloneDeep(this.defaultValue),
    }
  },
  computed: {
    isEditMode() {
      return this.defaultValue.id
    },
    isEmptyByOrderExtrafields() {
      return this.defaultValue.byOrderExtrafields instanceof Array || this.defaultValue.byOrderExtrafields === undefined
    },
    isEmptyBySizeExtrafields() {
      if (this.defaultValue.customerInfos.length === 0) return true
      return this.defaultValue.customerInfos[0].bySizeExtrafields instanceof Array
    },
    isUnpaid () {
      return this.defaultValue.status === 2
    }
  },
  created() {
    if (this.isEditMode) {
      this.watchComplexObject(this.submitData.byOrderExtrafields)
      this.submitData.customerInfos.map((customerInfo) => {
        this.watchComplexObject(customerInfo.bySizeExtrafields)
      })
    }
  },
  methods: {
    watchComplexObject(Extrafields) {
      if (!this.isEmptyExtrafields(Extrafields)) {
        for (let index in Extrafields) {
          this.$watch(() => Extrafields[index], this.updateExtrafields, {
            deep: true,
          })
        }
      }
    },
    isEmptyExtrafields(Extrafields) {
      return Extrafields instanceof Array
    },
    updateExtrafields(newValue, oldValue) {
      newValue.edited = true
    },
    resetEdit() {
      this.submitData = cloneDeep(this.defaultValue)
    },
  },
}
</script>

<template>
  <div>
    <el-row :gutter="20" :class="$style.th">
      <el-col :span="12"><span>序號</span></el-col>
      <el-col :span="12"><span>圖片上傳</span></el-col>
    </el-row>
    <el-row :gutter="20" v-if="!isEmptyBySizeExtrafields" :class="$style['column-body']">
      <div v-for="(customerInfo, index) in submitData.customerInfos" :key="`edit-customerInfo-${index}`" :title="`參與人 ${index + 1}`">
        <div v-for="(field, fieldIndex) in customerInfo.bySizeExtrafields" :key="`edit-customerInfo-${index}-${fieldIndex}`">
          <el-col v-if="field.adminEdit === 1 && field.type === 'light_image'" :span="12" :class="$style.column">
            <BaseUpload v-if="!isUnpaid" v-model="field.value" resource="staff" :height="56" :hide-notice="true" :margin-top="0" style="margin: 0 auto;" :class="disabled ? $style.disabled : ''" />
          </el-col>
          <el-col v-else-if="field.adminEdit === 1 && field.type === 'serial_number'" :span="12" :class="$style.column">
            <el-input v-if="!isUnpaid" v-model="field.value" type="text" :disabled="disabled"></el-input>
          </el-col>
        </div>
      </div>
    </el-row>
  </div>
</template>

<style lang="scss" module>
.disabled {
  pointer-events: none;
  opacity: 0.3;
}
.th {
  border-left: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
  margin-right: 0 !important;
  :global {
    .el-col {
      padding: 12px 0;
      span {
        // padding-left: 10px;
        padding-right: 10px;
        width: 100%;
        line-height: 23px;
        font-size: 14px;
        font-weight: 700;
        color: #909399;
      }
      &:last-child {
        border-left: 1px solid #ebeef5;
      }
    }
  }
}
.column-body {
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  margin-right: 0 !important;
}
.column {
  height: 80px;
  padding: 10px 0;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
</style>
